import { Typography } from "@mui/material";
import { palette, spacing } from "../../../styles/theme";
import {
  Box,
  FlexColBox,
  GradientChip,
  Icon,
} from "../../../common/components";
import { useTranslation } from "react-i18next";
import { FormattedPrice } from "../common/types";
import { CreditDetails } from "../../../types";

interface Props {
  productName: string;
  rawUnitPrice: FormattedPrice;
  creditUnitPrice: FormattedPrice;
  freeCredits?: number;
  formattedCredits: CreditDetails[];
  creditsUsed: number;
  extraCredits: number;
}

const ProductSection = ({
  productName,
  rawUnitPrice,
  creditUnitPrice,
  freeCredits,
  formattedCredits,
  creditsUsed,
  extraCredits,
}: Props) => {
  const { t } = useTranslation();
  const isSocks = productName.toLowerCase().includes("sock");
  return (
    <>
      <Typography variant="h2">{t("general.product")}</Typography>
      <FlexColBox
        width={"100%"}
        gap={{ xs: spacing.xsMobile, lg: spacing.xsDesktop }}
      >
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Typography variant="textRegularBold">
            {t(`${productName}.name`)}
          </Typography>
          <Typography variant="textRegularBold">
            {rawUnitPrice.formatted}
          </Typography>
        </Box>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Typography variant="textSm" color={palette.grey.primary}>
            {isSocks
              ? t("pricing.creditsSocks")
              : t("pricing.freeCredits", {
                  count: freeCredits ?? 0,
                  usedCredits: creditsUsed,
                  extraCredits: extraCredits,
                })}
          </Typography>
          <Typography variant="textSm" color={palette.grey.nearBlack}>
            +{creditUnitPrice.formatted}
          </Typography>
        </Box>
      </FlexColBox>
      <FlexColBox
        gap={{ xs: spacing.smallMobile, lg: spacing.smallDesktop }}
        ml={"8px"}
      >
        {formattedCredits.map((c) => (
          <Box key={c.id} display="flex" gap={"4px"} alignItems={"center"}>
            <Box display="flex" gap={"8px"} alignItems={"center"}>
              <Icon
                icon="circle"
                filled
                color={palette.grey.primary}
                size={4}
              />
              <Typography variant="textSm" color={palette.grey.primary}>
                {c.name}
              </Typography>
            </Box>
            <GradientChip>
              {t("general.credits", { count: c.credits })}
            </GradientChip>
          </Box>
        ))}
      </FlexColBox>
    </>
  );
};

export default ProductSection;
